import { Avatar as MuiAvatar } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

type AvatarSize = "50px" | "100px" | "150px";

type AvatarProps = {
  size?: AvatarSize;
  [key: string]: any;
};

type StyleProps = {
  size: AvatarSize | undefined;
};

const useStyles = makeStyles(() => ({
  avatar: (props: StyleProps) => ({
    height: props.size,
    width: props.size,
  }),
}));

const Avatar = ({ size, ...props }: AvatarProps) => {
  const classes = useStyles({ size });
  
  return <MuiAvatar className={size ? classes.avatar : undefined} {...props} />;
};

export default Avatar;
